import { render, staticRenderFns } from "./IntellectualPropertyIcon.vue?vue&type=template&id=d9f71868"
import script from "./IntellectualPropertyIcon.vue?vue&type=script&lang=js"
export * from "./IntellectualPropertyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports